import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '../shared/http-client';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { DatosImportacionViewModel } from '../models/viewmodels/datosImportacionViewModel';
import { ListadoClientes } from '../models/viewmodels/listadoClientes';
import { ClienteViewModel } from '../models/viewmodels/clienteViewModel';
import { ListadoMovimientos } from '../models/viewmodels/listadoMovimientos';

@Injectable()
export class ClienteService {

  private clienteActual: ClienteViewModel;
  public clientesUsuario: Array<ClienteViewModel> = [];

  clienteEmitter = new EventEmitter<ClienteViewModel>();

  constructor(private httpClient: HttpClient) { }

  setCliente(cliente: ClienteViewModel) {
    this.clienteActual = cliente;
    this.clienteEmitter.emit(cliente);
  }

  getCliente() {
    return this.clienteActual;
  }

  listado(pagina: number, cantidadPorPagina: number, query: string): Observable<ListadoClientes> {
    // get users from api
    return this.httpClient.get(`/clientes/?pagina=${pagina}&cantidadPorPagina=${cantidadPorPagina}&query=${query}`)
      .map(response => {
        return response.json();
      });
  }

  importarCtaCte(file: File, datos: DatosImportacionViewModel, comprobantes:File) {

    let postData = { datos: JSON.stringify(datos) };

    return comprobantes == null 
      ? this.httpClient.postWithFile("/clientes/importar", postData, { file: file, name: 'zip' })
      : this.httpClient.postWithFiles("/clientes/importar", postData, [{file: comprobantes, name: 'comprobantes'}, { file: file, name: 'zip' }]);
  }

  obtenerHistorica(clienteId: string, pagina: number, cantidadPorPagina: number) {
    return this.httpClient.get(`/clientes/${clienteId}/ctacte/historica/?pagina=${pagina}&cantidadPorPagina=${cantidadPorPagina}`)
      .map(response => {
        return response.json();
      });
  }

  obtenerAplicada(clienteId: string, pagina: number, cantidadPorPagina: number) {
    return this.httpClient.get(`/clientes/${clienteId}/ctacte/aplicada/?pagina=${pagina}&cantidadPorPagina=${cantidadPorPagina}`)
      .map(response => {
        return response.json();
      });
  }

  obtenerSaldo(clienteId:string){
    return this.httpClient.get(`/clientes/${clienteId}/ctacte/saldo`)
    .map(response => {
      return response.json();
    });
  }

  obtenerComprobante(clienteId: string, comprobante: string) {    
    
    return this.httpClient.get(`/clientes/${clienteId}/movimientos/${comprobante}/descargar`, true);
  }

  guardar(cliente: ClienteViewModel){
    return this.httpClient.put('/clientes/', cliente);
  }
  
  reenviarRegistracion(id:string){
    return this.httpClient.post(`/clientes/${id}/reenviar/registracion`, null);
  }

  obtenerEmail(id:string) {
        return this.httpClient.get(`/clientes/${id}/email/registracion`);            
  }

  eliminar(id: string) {
      return this.httpClient.delete(`/clientes/${id}`);
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/cliente.service.ts